import { assign, clone, cloneDeep } from 'lodash'

import * as playerPage from './PlayerPageActions'

export default (state = playerPage.PLAYER_PAGE_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case playerPage.PLAYER_PAGE_FETCH: {
      return clone(playerPage.PLAYER_PAGE_INITIAL_STATE)
    }
    case playerPage.PLAYER_PAGE_FETCH_CANCELED: {
      return clone(playerPage.PLAYER_PAGE_INITIAL_STATE)
    }
    case playerPage.PLAYER_PAGE_FETCH_ERROR: {
      return assign({}, playerPage.PLAYER_PAGE_INITIAL_STATE, { error: action.payload })
    }
    case playerPage.PLAYER_PAGE_FETCH_FULFILLED: {
      return cloneDeep(action.payload)
    }

    default:
  }
  return state
}
